<template>
  <section>
    <div @click="hideLicenseKeyBoard" class="checkin-cont" v-if="!isAddPerson">
      <div class="warn">
        填写前请注意：<br />
        1.请务必如实填写，如提供虚假信息一律禁止进厂;<br />
        2.禁止提前报到，必须到厂门口后才能报到，如因提前报到造成不能进厂的，一切后果自负。
      </div>
      <div class="cont1">
        <div class="car-license">
          <div class="car-license-title">请选择车牌</div>
          <div :class="licenseType === 'normal'
            ? 'car-license-btn-active'
            : 'car-license-btn'
            " @click="changeBtn(0)">
            普通车牌
          </div>
          <div :class="licenseType === 'newEnergy'
            ? 'car-license-btn-active'
            : 'car-license-btn'
            " @click="changeBtn(1)">
            新能源车牌
          </div>
          <div :class="licenseType === 'HKorMacao'
            ? 'car-license-btn-active'
            : 'car-license-btn'
            " @click="changeBtn(2)">
            港澳车牌
          </div>
          <div class="car-license-title">请输入车牌号</div>
          <LicenseKeyBorad :type="licenseType" ref="licenseKeyBoard" @setLicense="setLicense" :showRecentUse="true"
            @click.stop="showLicenseKeyBoard" :licenseValue="licenseValue" />
        </div>
      </div>
      <div class="cont2">
        <van-cell-group class="requried">
          <van-field v-model="params.name" label="司机姓名" placeholder="请输入姓名" />
          <van-field v-model="params.cardNum" label="司机身份证" placeholder="请输入身份证" />
          <van-field v-model="params.phone" label="司机手机" placeholder="请输入司机手机" />
        </van-cell-group>
      </div>
      <div class="cont3">
        <div class="title">随行人员</div>
        <div v-for="(item, index) in personArr" :key="index" style="margin: 0px 0px 10px;">
          <div class="closebtn">
            <van-icon name="close" @click="deletePerson(index)" />
          </div>
          <div class="list requried" @click="editPerson(item, index)">
            <van-field v-model="item.name" label="人员姓名" readonly />
            <van-field v-model="item.id_card" label="身份证号码" readonly />
            <van-field v-model="item.contact" label="联系方式" readonly />
          </div>
        </div>
        <div class="addbtn">
          <img src="../assets/img/add.png" alt="" width="25px" />
          <span class="addbtn-span" @click="addPerson">添加随行人员</span>
        </div>
      </div>
      <div style="height: 86px;background-color: #f4f5f6;"></div>
      <div class="cont4">
        <van-button type="primary" block class="btnStyle1" @click="saveSignIn">提交</van-button>
      </div>
    </div>

    <div v-if="isAddPerson" class="checkin-cont">
      <div style="border-top: 1px solid #f4f5f6;">
        <div class="cont5" v-for="(item, index) in addPersonArr" :key="index">
          <div style="display: flex;align-items: center;padding: 18px 16px 18px;">
            <img src="../assets/img/circle.png" alt="" width="22px" style="margin-right: 7px;" />
            <span style="color: #009967;line-height: 22px;">随行人员</span>
            <!-- {{ pageTag === "edit" ? "" : index + 1 }} -->
          </div>
          <div>
            <van-cell-group class="requried">
              <van-field v-model="item.name" label="人员姓名" placeholder="请输入姓名" />
              <van-field v-model="item.id_card" label="身份证号码" placeholder="请输入身份证号码" />
              <van-field v-model="item.contact" label="联系方式" placeholder="请输入手机号码" />
            </van-cell-group>
          </div>
        </div>
        <div class="cont6">请如实填写所有随行人员信息</div>
        <div style="height: 130px;background-color: #f4f5f6;"></div>
        <div class="cont4">
          <van-button type="primary" block class="btnStyle1" @click="savePerson(0)">保存</van-button>
          <van-button block class="btnStyle2" @click="savePerson(1)" v-if="pageTag === 'add'">保存并继续添加</van-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LicenseKeyBorad from "../../../components/license";
import { Dialog, Toast } from "vant";
export default {
  components: {
    LicenseKeyBorad
  },
  data() {
    return {
      licenseType: "normal",
      licenseValue: "", //车牌值
      params: {
        name: "",
        cardNum: "",
        phone: ""
      },
      pageTag: "default",
      isAddPerson: false,
      personArr: [],
      addPersonArr: [
        {
          name: "",
          id_card: "",
          contact: ""
        },
        {
          name: "",
          id_card: "",
          contact: ""
        }
      ],
      saveSuccess: false, // 是否提交报到信息成功
      rowDataObj: {}, // 缓存对象
      checkInInterval: null // 2秒钟缓存报到数据
    };
  },
  beforeRouteUpdate(a, b, n) {
    console.log(123213213, a, b);
    this.isAddPerson = !this.isAddPerson;
    if (String(this.addPerson) === "true") {
      if (String(a.params.id) === "1") {
        document.title = "添加随行人员";
      } else if (String(a.params.id) === "2") {
        document.title = "编辑随行人员";
      }
    } else {
      document.title = "现场报到";
    }
    n();
  },
  methods: {
    // 切换按钮
    changeBtn(val) {
      // if (this.licenseType === "normal") {
      //   this.licenseType = "newEnergy";
      // } else {
      //   this.licenseType = "normal";
      // }
      if (val == 0) {
        this.licenseType = "normal";
      }
      if (val == 1) {
        this.licenseType = "newEnergy";
      }
      if (val == 2) {
        this.licenseType = "HKorMacao";
      }
      this.$refs.licenseKeyBoard.emptyArray(); //清空内容
    },

    // 获取键盘数据
    setLicense(first, numArr) {
      this.licenseValue = first + numArr.join("");
    },

    // 隐藏键盘
    hideLicenseKeyBoard() {
      if (!this.isAddPerson) {
        this.$refs.licenseKeyBoard.close_keyboard();
      }
    },

    // 弹起键盘
    showLicenseKeyBoard() {
      if (!this.isAddPerson) {
        this.$refs.LicenseKeyBorad.clickShowKeyboard();
      }
    },

    // 删除人员
    deletePerson(index) {
      Dialog.confirm({
        title: "确认提醒",
        message: "确认要删除此随行人员？",
        confirmButtonColor: "#009967"
      }).then(() => {
        // on confirm
        this.personArr.splice(index, 1);
      });
    },

    // 添加随行人员
    addPerson() {
      this.pageTag = "add";
      this.$router.push({
        path: "/rhwxCheckin/1",
        query: {
          com_id: this.$route.query.com_id,
          sub_com_id: this.$route.query.sub_com_id,
          map_type: this.$route.query.map_type
        }
      });
      this.isAddPerson = true;
      document.title = "添加随行人员";
      this.addPersonArr = [
        {
          name: "",
          id_card: "",
          contact: ""
        }
      ];
    },

    // 保存随行人员
    // tag === 0 保存  tag === 1 保存并继续添加
    savePerson(tag) {
      // ${i + 1}
      for (let i = 0; i < this.addPersonArr.length; i++) {
        if (this.addPersonArr[i].name.trim() === "") {
          this.$common.mbToastFail(`人员姓名不能为空`);
          return false;
        }
        if (this.addPersonArr[i].id_card.trim() === "") {
          this.$common.mbToastFail(`身份证号码不能为空`);
          return false;
        }
        if (
          !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
            this.addPersonArr[i].id_card.trim()
          )
        ) {
          this.$common.mbToastFail(`身份证号码格式不正确`);
          return;
        }
        if (this.addPersonArr[i].contact.trim() === "") {
          this.$common.mbToastFail(`联系方式不能为空`);
          return false;
        }
        if (!/^1[0-9]{10}$/.test(this.addPersonArr[i].contact.trim())) {
          this.$common.mbToastFail(`联系方式格式不正确`);
          return;
        }
      }
      // 保存
      if (tag === 0) {
        if (this.pageTag === "edit") {
          this.personArr[Number(this.addPersonArr[0].index)] = {
            contact: this.addPersonArr[0].contact,
            id_card: this.addPersonArr[0].id_card,
            name: this.addPersonArr[0].name
          };
        } else {
          this.addPersonArr.forEach(item => {
            console.log(item);
            this.personArr.push(item);
          });
        }
        this.pageTag = "default";
        this.isAddPerson = false;
        this.$router.push({
          path: "/rhwxCheckin/0",
          query: {
            com_id: this.$route.query.com_id,
            sub_com_id: this.$route.query.sub_com_id,
            map_type: this.$route.query.map_type
          }
        });
        this.isAddPerson = false;
        document.title = "现场报到";
      } else {
        // 保存并继续添加
        this.addPersonArr.forEach(item => {
          console.log(item);
          this.personArr.push(item);
        });
        Toast.success("保存成功");
        this.addPersonArr = [
          {
            name: "",
            id_card: "",
            contact: ""
          }
        ];
      }
    },

    // 编辑随行人员
    editPerson(item, index) {
      this.pageTag = "edit";
      this.$router.push({
        path: "/rhwxCheckin/2",
        query: {
          com_id: this.$route.query.com_id,
          sub_com_id: this.$route.query.sub_com_id,
          map_type: this.$route.query.map_type
        }
      });
      this.isAddPerson = true;
      document.title = "编辑随行人员";
      this.addPersonArr = [
        {
          contact: item.contact,
          id_card: item.id_card,
          name: item.name,
          index: index
        }
      ];
    },

    // 提交报到信息
    async saveSignIn() {
      if (this.licenseValue.trim() === "") {
        this.$common.mbToastFail("车牌号不能为空");
        return false;
      }
      if (
        (this.licenseValue.trim().length < 7 &&
          this.licenseType === "normal") ||
        (this.licenseValue.trim().length < 8 &&
          this.licenseType === "newEnergy") ||
        (this.licenseValue.trim().length < 7 &&
          this.licenseType === "HKorMacao")
      ) {
        this.$common.mbToastFail("请完善车牌号");
        return false;
      }
      if (this.params.name.trim() === "") {
        this.$common.mbToastFail("司机姓名不能为空");
        return false;
      }
      if (this.params.cardNum.trim() === "") {
        this.$common.mbToastFail("司机身份证不能为空");
        return false;
      }
      if (
        !/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          this.params.cardNum.trim()
        )
      ) {
        this.$common.mbToastFail("司机身份证的格式不正确");
        return false;
      }
      if (this.params.phone.trim() === "") {
        this.$common.mbToastFail("司机手机不能为空");
        return false;
      }
      if (!/^1[0-9]{10}$/.test(this.params.phone.trim())) {
        this.$common.mbToastFail("司机手机的格式不正确");
        return false;
      }
      let license_plate_type = "";
      if (this.licenseType == "normal") {
        license_plate_type = 0;
      }
      if (this.licenseType == "newEnergy") {
        license_plate_type = 1;
      }
      if (this.licenseType == "HKorMacao") {
        license_plate_type = 2;
      }
      let data = {
        com_id: this.$route.query.sub_com_id,
        // license_plate_type: this.licenseType === "normal" ? 0 : 1,
        license_plate_type,
        license_plate: this.licenseValue,
        name: this.params.name,
        id_card: this.params.cardNum.toUpperCase(),
        contact: this.params.phone,
        entourages: JSON.stringify(this.personArr)
      };
      console.log(data);

      // 检查是否存在预约数据，如果存则继续执行后面代码，请求抛出异常，reject，不执行后面逻辑
      await this.$common.http({
        url: "/api/queue/driver/check_submit_report",
        data: data
      });

      // this.$common
      //   .http({
      //     url: "/api/queue/driver/submit_report",
      //     data: data
      //   })
      //   .then(res => {
      //     console.log(res);
      //     this.$common.mbToastSuccess("提交成功");
      //     this.saveSuccess = true;
      //     // localStorage.setItem(
      //     //   "safetyNotice",
      //     //   JSON.stringify(res.data.data.safetyNotice)
      //     // );
      //     this.$common
      //       .http({
      //         url: "/api/queue/driver/query_report_info",
      //         data: {
      //           com_id: this.$route.query.sub_com_id
      //         }
      //       })
      //       .then(res => {
      //         console.log(res);
      //         // 1 立即报到  2 再次报到-已有业务  3 再次报到-正常报到  4-重新报到
      //         this.rowDataObj = res.data.data.safetyNotice;
      //         if (this.rowDataObj.length > 0) {
      //           setTimeout(() => {
      //             this.$router.push({
      //               path: "/rhwxNotice",
      //               query: {
      //                 com_id: this.$route.query.com_id,
      //                 sub_com_id: this.$route.query.sub_com_id,
      //                 map_type: this.$route.query.map_type
      //               }
      //             });
      //           }, 1200);
      //         } else {
      //           this.$common.mbToastFail("当前无排队安全告知书信息！");
      //           setTimeout(() => {
      //             this.$router.push({
      //               path: "/rhwxSignInSuccess",
      //               query: {
      //                 com_id: this.$route.query.com_id,
      //                 sub_com_id: this.$route.query.sub_com_id,
      //                 map_type: this.$route.query.map_type
      //               }
      //             });
      //           }, 1200);
      //         }
      //       });
      //     window.clearInterval(this.checkInInterval);
      //     this.checkInInterval = 0;
      //     localStorage.removeItem("checkIn");
      //   });

      // 调整
      localStorage.setItem("submitCheckIn", JSON.stringify(data));
      this.saveSuccess = true;
      this.$common
        .http({
          url: "/api/queue/driver/query_report_info",
          data: {
            com_id: this.$route.query.sub_com_id
          }
        })
        .then(res => {
          console.log(res);
          // 1 立即报到  2 再次报到-已有业务  3 再次报到-正常报到  4-重新报到
          this.rowDataObj = res.data.data.safetyNotice;
          if (this.rowDataObj.length > 0) {
            setTimeout(() => {
              this.$router.push({
                path: "/rhwxNotice",
                query: {
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id,
                  map_type: this.$route.query.map_type
                }
              });
            }, 1200);
          } else {
            this.$common.mbToastFail("当前无排队安全告知书信息！");
            setTimeout(() => {
              this.$router.push({
                path: "/rhwxSignInSuccess",
                query: {
                  com_id: this.$route.query.com_id,
                  sub_com_id: this.$route.query.sub_com_id,
                  map_type: this.$route.query.map_type
                }
              });
            }, 1200);
          }
        });
      window.clearInterval(this.checkInInterval);
      this.checkInInterval = null;
      localStorage.removeItem("checkIn");
    },

    // 缓存页面信息
    beforeunloadFn() {
      if (!this.saveSuccess) {
        let obj = {
          licenseType: this.licenseType,
          licenseValue: this.licenseValue,
          params: this.params,
          personArr: this.personArr
        };
        localStorage.setItem("checkIn", JSON.stringify(obj));
      } else {
        window.clearInterval(this.checkInInterval);
        this.checkInInterval = null;
        localStorage.removeItem("checkIn");
      }
    },
    getReportInfo() {
      this.$common.http({
        url: "/api/queue/driver/get_report_info",
        method: "GET",
        data: {
          com_id: this.$route.query.sub_com_id
        }
      }).then((res) => {
        if (res.data.data && res.data.data.name) {
          Dialog.confirm({
            title: '报到信息快速填充',
            message: '系统检查到该司机今天已经报到过，是否快速填充报到信息？',
          })
            .then(() => {
              let dataObj = res.data.data;
              this.params = {
                name: dataObj.name,
                cardNum: dataObj.id_card,
                phone: dataObj.contact
              }
              let license_plate_type = ""
              if (dataObj.license_plate_type == 0) {
                license_plate_type = "normal";
              }
              if (dataObj.license_plate_type == 1) {
                license_plate_type = "newEnergy";
              }
              if (dataObj.license_plate_type == 2) {
                license_plate_type = "HKorMacao";
              }
              this.licenseType = license_plate_type
              this.licenseValue = dataObj.license_plate
              this.personArr = dataObj.entourage
            })
            .catch(() => {
              // on cancel
            });
        }
      })
    }
  },

  created() {
    // window.addEventListener("beforeunload", e => this.beforeunloadFn(e));
    // 2秒钟定时刷新，缓存数据
    this.checkInInterval = window.setInterval(() => {
      this.beforeunloadFn();
    }, 2000);
    this.rowDataObj = JSON.parse(localStorage.getItem("checkIn"));
    if (this.rowDataObj) {
      this.licenseType =
        this.rowDataObj.licenseType === "" ? "" : this.rowDataObj.licenseType;
      this.licenseValue =
        this.rowDataObj.licenseValue === "" ? "" : this.rowDataObj.licenseValue;
      this.params = this.rowDataObj.params;
      this.personArr = this.rowDataObj.personArr;
    }
    this.getReportInfo();
  },

  beforeRouteLeave(_to, _form, next) {
    window.clearInterval(this.checkInInterval);
    this.checkInInterval = null;
    localStorage.removeItem("checkIn");
    next();
  }

  // beforeDestroy() {
  //   this.beforeunloadFn();
  // },

  // destroyed() {
  //   window.removeEventListener("beforeunload", e => this.beforeunloadFn(e));
  // }
};
</script>
<style lang="less">
@import "../assets/css/common";

.customFailToastClass {
  width: 60% !important;
}

.checkin-cont {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;

  .warn {
    background: #e7fbf7;
    font-size: 13px;
    color: #009967;
    padding: 10px 17px;
    line-height: 19px;
  }

  .cont1 {
    padding: 10px 16px 18px;
    background: #fff;

    .car-license {
      &-title {
        font-size: 17px;
        margin: 8px 0px 19px;
      }

      &-btn-active {
        display: inline-block;
        background: #00c8d2;
        color: white;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 20px 10px 0px;
      }

      &-btn {
        display: inline-block;
        background: #f6f6f7;
        color: #00c8d2;
        font-size: 13px;
        padding: 9px 18px;
        border-radius: 4px;
        margin: 0px 20px 10px 0px;
      }
    }
  }

  .cont2 {
    margin: 10px 0px;
  }

  .cont3 {
    background: #fff;
    padding: 10px 16px;
    font-size: 17px;

    .title {
      margin: 4px 0px 12px;
    }

    .closebtn {
      vertical-align: top;
      font-size: 22px;
      opacity: 0.5;
      z-index: 10;
      position: relative;
      text-align: right;
      border-radius: 50%;
    }

    .list {
      background: #f6f6f7;
      border-radius: 5px;
      margin-top: -20px;
    }

    .addbtn {
      display: flex;
      align-items: center;
      margin: 18px 0px 13px 0px;

      &-span {
        color: #009967;
        margin-left: 7px;
      }
    }
  }

  .cont4 {
    // padding: 29px 15px;
    // background: #f4f5f6;
    bottom: 0px;
    width: 90%;
    position: fixed;
    background: #f4f5f6;
    padding: 15px 5%;
    z-index: 11;
  }

  .cont5 {
    background: #fff;
    font-size: 18px;
    color: #009967;
    line-height: 17px;
  }

  .cont6 {
    font-size: 14px;
    color: #ec3f67;
    text-align: center;
    padding: 14px 0px;
  }
}

.van-cell {
  background-color: inherit;
  border-radius: 5px;
  font-size: 17px;
  height: 56px;
  line-height: 38px;
}

.van-cell::after {
  border-bottom: 1px solid #dcdcdd;
}

.van-field__label {
  color: #000;
  margin-right: 23px;
}

.van-dialog__message {
  font-size: 16px;
}
</style>
